import React from "react";
import MapPinSVG from "assets/icons/map-pin.inline.svg";
import Icon from "./Icon";

const MapPinFilledV2 = ({ ...rest }) => (
	<Icon
		name="map-pin-filled"
		alt="Map pin"
		size="large"
		{...rest}
	>
		<MapPinSVG />
	</Icon>
);

export default MapPinFilledV2;
